import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCollectionJarBlueFlowersEmpty extends Item {
    constructor() {
        super(definitions.ITEM_ID.COLLECTION_JAR_BLUE_FLOWERS_EMPTY, texture("prop_empty_jar_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}